import React from 'react';
import { useTranslation } from 'react-i18next';
import { LevelSelection } from '../LevelSelection';
import { Level, level1, level2 } from '../../domain/level';
import { Button } from '../Common/Button';
import { createUseStyles } from 'react-jss';
import backgroundImage from '../../assets/images/background.png';

export interface ILevelSelectViewProps {
    onSelectLevel(level: Level): void;
    onShowMenu(): void;
}

const useStyles = createUseStyles({
    root: {
        backgroundImage: `url(${backgroundImage})}`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        height: '100%',
        position: 'relative',
    },
    block: {
        height: '100%',
    },
    title: {
        margin: 0,
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
    },
});

export const levelSelectionViewKey = 'levelSelection';

const levels = [
    level1,
    level2,
];

export const LevelSelectionView: React.FunctionComponent<ILevelSelectViewProps> = props => {
    const styles = useStyles();
    const { t } = useTranslation();

    return (
        <div className={styles.root}>
            <div className={styles.block}>
                <div className={styles.container}>
                    <h1 className={styles.title} aria-live="polite">{t('levelSelection.title')}</h1>
                    <LevelSelection
                        levels={levels}
                        onSelectLevel={props.onSelectLevel}
                    />
                    <Button onClick={props.onShowMenu}>{t('back')}</Button>
                </div>
            </div>
        </div>
    );
};
